export enum ThemeSids {
  aba = 'aba',
  abatest = 'abatest',
  jig = 'jig',
  talentpool = 'talentpool',
  edunet = 'edunet',
  wconat = 'wconat',
  ncph = 'ncph',
  t4a = 't4a',
  abaooe = 'abaooe',
  amseu = 'amseu',
}

export interface ThemeSite {
  domain?: string
  sid: ThemeSids
  color: string
  title?: any
  language?: string
  languageDropdown: boolean
  // TODO тимчасова заглушка: гейт вимагає demo-логін перед доступом до сайту
  accessGate?: boolean
}
